"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));
var _react = _interopRequireWildcard(require("react"));
var _Alert = _interopRequireDefault(require("react-bootstrap/Alert"));
var AlertFeedback = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(AlertFeedback, _Component);
  var _super = (0, _createSuper2.default)(AlertFeedback);
  function AlertFeedback(props) {
    var _this;
    (0, _classCallCheck2.default)(this, AlertFeedback);
    _this = _super.call(this, props);
    _this.ref = /*#__PURE__*/_react.default.createRef();
    return _this;
  }
  (0, _createClass2.default)(AlertFeedback, [{
    key: "render",
    value: function render() {
      var _this$props$incorrect, _this$props$correct;
      var incorrect = (_this$props$incorrect = this.props.incorrect) !== null && _this$props$incorrect !== void 0 ? _this$props$incorrect : !((_this$props$correct = this.props.correct) !== null && _this$props$correct !== void 0 ? _this$props$correct : true);
      return /*#__PURE__*/_react.default.createElement(_Alert.default, {
        ref: this.ref,
        className: this.props.className,
        variant: incorrect ? "danger" : "success",
        style: {
          textAlign: 'left'
        }
      }, this.props.feedback, this.props.children);
    }
  }]);
  return AlertFeedback;
}(_react.Component);
exports.default = AlertFeedback;